// extracted by mini-css-extract-plugin
module.exports = {"content":"edit-wishlist-dialog_content__X_agY","wrapper":"edit-wishlist-dialog_wrapper__JM6BV"};